export default __webpack_public_path__ + "static/media/evans.64ee6f43.webp";